import transactionUtils from './transaction-utils';

const store = {
  namespaced: true,
  state: {
    transactions: [],
    ready: false,

    employerId: null,
    planId: null,
    participantId: null,
    accountId: null,
    locationId: null,

    startDate: null,
    endDate: null,
    minimumAmount: null,
    maximumAmount: null,
    selectedStatuses: [],
    selectedTransactionCodes: [],
  },
  getters: {
    transaction: (state) => (accountTransactionId) => {
      //console.log("x-transactions transaction getter accountTransactionId: ", accountTransactionId);
      return state.transactions.find(x => x.accountTransactionId == accountTransactionId);
    },
    limit() {
      return 1000;
    },
    searchFiltersState: (state) => {
      return mapFilters(state);
    }
  },
  actions: {
    async clear({commit}) {
      commit("setTransactions", []);
      commit("setReady", true);
    },
    async load({state, getters, commit}, data) {
      //console.log("x-transactions load data: ", data);
      let transactions = null;

      commit("setReady", false);
      commit("setFilters", data);

      if(!data || !(data.employerId || data.participantId))
        throw "Searching transactions requires an employerId or participantId!";

      let entityType = data.employerId ? "employer" : "participant";
      let id = data.employerId || data.participantId;
      let transactionsUrl = entityType + "/" + id + "/transaction/search";

      let filters = mapFilters(state);
      filters.transactions = undefined;
      filters.limit = getters.limit;

      await Promise.all([romeApi.post(transactionsUrl, filters)])
      .then(([transactionsResult]) => {
        transactions = transactionsResult;
      });

      //console.log("x-transactions load transactions: ", transactions);
      commit("setTransactions", transactions);
      commit("setReady", true);
    },
    async createAdjustment(context, data) {
      await romeApi.post(`/participant/${data.participantId}/account/${data.accountId}/adjustment`, data);
      this.dispatch("accounts/load", { participantId: data.participantId, force: true });
      },
  },
  mutations: {
    setFilters(state, filters) {
      for (let key in state) { state[key] = null; }
      Object.assign(state, filters);
    },
    setTransactions(state, transactions) {
      state.transactions = transactions;
    },
    setReady(state, ready) {
      state.ready = ready;
    },
  }
};

function mapFilters(state) {
  let filters = {
    employerId: state.employerId,
    planId: state.planId,
    participantId: state.participantId,
    accountId: state.accountId,
    locationId: state.locationId,
    minAmount: state.minimumAmount,
    maxAmount: state.maximumAmount,
  };

    let from = new Date();
    from.setFullYear( from.getFullYear() - 20 );
    filters.from = state.startDate || from;
    filters.to = state.endDate;
    state.selectedStatuses.forEach(status => filters[status] = true);
    state.selectedTransactionCodes.forEach(code => filters[code] = true);

    //console.log("x-transactions mapFilters filters: ", filters);
return filters;
}

export default store;



// WEBPACK FOOTER //
// ./src/transactions/x-transactions.js